import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-file-alternate-2-icon',
  template: `<svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.12"
      d="M12.7477 4.7476L9.91928 1.91918C9.74827 1.74816 9.54947 1.61131 9.3335 1.51303V4.26673C9.3335 4.64009 9.3335 4.82678 9.40616 4.96938C9.47007 5.09483 9.57206 5.19681 9.6975 5.26073C9.84011 5.33339 10.0268 5.33339 10.4002 5.33339H13.1539C13.0556 5.11742 12.9187 4.91862 12.7477 4.7476Z"
      [attr.fill]="color"
    />
    <path
      d="M9.33317 1.51298V4.26668C9.33317 4.64005 9.33317 4.82673 9.40583 4.96934C9.46975 5.09478 9.57174 5.19677 9.69718 5.26068C9.83978 5.33334 10.0265 5.33334 10.3998 5.33334H13.1535M13.3332 6.65883V11.4667C13.3332 12.5868 13.3332 13.1468 13.1152 13.5747C12.9234 13.951 12.6175 14.2569 12.2412 14.4487C11.8133 14.6667 11.2533 14.6667 10.1332 14.6667H5.8665C4.7464 14.6667 4.18635 14.6667 3.75852 14.4487C3.3822 14.2569 3.07624 13.951 2.88449 13.5747C2.6665 13.1468 2.6665 12.5868 2.6665 11.4667V4.53334C2.6665 3.41324 2.6665 2.85319 2.88449 2.42536C3.07624 2.04904 3.3822 1.74308 3.75852 1.55133C4.18635 1.33334 4.7464 1.33334 5.8665 1.33334H8.00769C8.49687 1.33334 8.74146 1.33334 8.97163 1.3886C9.17571 1.4376 9.3708 1.51841 9.54974 1.62806C9.75157 1.75175 9.92453 1.9247 10.2704 2.2706L12.3959 4.39608C12.7418 4.74199 12.9148 4.91494 13.0385 5.11677C13.1481 5.29572 13.2289 5.49081 13.2779 5.69488C13.3332 5.92505 13.3332 6.16965 13.3332 6.65883Z"
      [attr.stroke]="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg> `,
})
export class FileAlternate2Icon extends BaseIconComponent {}
